import type { ComponentProps } from "react"

import { APARENCIA_DE_CAMPO } from "../lib/classes"
import { cn } from "../lib/cn"
import * as Icones from "./Icones"

function NativeSelect({
  className,
  classNameDaCaixa,
  children,
  ...props
}: ComponentProps<"select"> & {
  classNameDaCaixa?: string
}) {
  return (
    <div className={cn("relative", classNameDaCaixa)}>
      <select
        data-slot="native-select"
        className={cn(
          "h-9 w-full appearance-none border border-input px-3 py-1 pr-8 text-sm text-foreground transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:text-muted-foreground user-invalid:border-destructive",
          APARENCIA_DE_CAMPO,
          "focus-visible:border-ring",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <span className="pointer-events-none absolute top-1/2 right-2.5 -translate-y-1/2 text-muted-foreground">
        <Icones.Aumentar />
      </span>
    </div>
  )
}

export { NativeSelect }
